module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/attendance/attendance.html
// module id = 481
// module chunks = 0